export * from './tag';

//# sourceMappingURL=index.js.map